<template>
  <div class="vd-gl-content">
    <a-form-model
      ref="ruleForm"
      :label-col="labelCol"
      :rules="rules"
      :model="form"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="名称" prop="codeType">
        <a-input
          class="vd-input-s"
          v-model="form.name"
          placeholder="资料包名称"
        />
      </a-form-model-item>
      <a-form-model-item label="发布资料类型" prop="codeType">
        <a-radio-group
          name="sub_multi"
          :default-value="form.codeType"
          v-model="form.codeType"
        >
          <a-radio :value="1"> 单科目模式</a-radio>
          <a-radio :value="2"> 多科目模式</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="过期时间" prop="due_time">
        <a-date-picker
          :showToday="false"
          v-model="form.due_time"
          placeholder="推广码过期时间"
          format="YYYY-MM-DD"
          @change="dateChange"
          :disabled-date="disabledDate"
        >
          <template slot="renderExtraFooter">
            <a-tag @click="selectDate(7)"> 7天</a-tag>
            <a-tag @click="selectDate(30)"> 1个月</a-tag>
            <a-tag @click="selectDate(90)"> 3个月</a-tag>
            <a-tag @click="selectDate(180)"> 半年</a-tag>
            <a-tag @click="selectDate(360)"> 一年</a-tag>
          </template>
        </a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="转发分享封面图:" required>
        <div style="display: flex;align-items:flex-end;">
          <div style="margin-right: 20px;">
            <img :src="form.fenxiang" style="width: 260px" alt="" />
            <!-- 图片上传 -->
          </div>
          <div style="position:relative;width: 100%;height: 100%">
            <a-button type="link" @click="useDefaultFenxiang"
              >使用默认图片</a-button
            >
            <a-upload
              accept=".png,.jpg,.jpeg"
              :action="uploadUrl"
              @change="onChanges"
              :data="{ remark: '白皮书分享封面图' }"
              :show-upload-list="false"
              :beforeUpload="beforeShareUpload"
            >
              <div>
                <a-button icon="cloud-upload"> 重新上传</a-button>
                <span class="common-mute">
                  请上传宽高比为 500:400px，并且小于1 MB的图片</span
                >
              </div>
            </a-upload>
          </div>
        </div>
      </a-form-model-item>
      <template v-if="form.codeType === 2">
        <a-form-model-item label="添加资料分组" required>
          <a-input
            v-model="new_name"
            class="vd-input-s"
            placeholder="输入资料包名称"
          />
          <span class="common-mute"> {{ new_name.length }}/15 </span>

          <a-icon
            @click="addNewPackage"
            type="plus-circle"
            style="font-size: 20px;margin-left: 8px;cursor: pointer;"
          />
        </a-form-model-item>
      </template>
      <a-form-model-item label="资料领取封面图" required>
        <div style="display: flex;align-items:flex-end;">
          <div
            style="width: 260px;height: 480px;border: 1px solid #999999;margin-right: 20px;"
          >
            <div style="overflow: hidden;height: 100%">
              <img :src="bookHead" width="260px" alt="" />
              <div style="position:relative;width: 100%;height: 100%;">
                <img
                  style="position: absolute;"
                  :src="form.fengmian"
                  width="260px"
                  alt=""
                />
                <template v-if="form.codeType === 1">
                  <span class="head-button"> 点我领取</span>
                </template>
                <template v-else>
                  <div class="common-mute head-message">
                    请选择要领取的资料包
                  </div>
                  <div class="head-button-group">
                    <template v-if="materialGroup.length > 0">
                      <template v-for="(item, index) in materialGroup">
                        <span :key="index"> {{ item.name }}</span>
                      </template>
                    </template>
                  </div>
                  <span class="head-button"> 点我领取</span>
                </template>
              </div>
            </div>
          </div>
          <div>
            <a-button type="link" @click="useDefaultFace"
              >使用默认图片</a-button
            >
            <a-upload
              accept=".png,.jpg,.jpeg"
              :action="uploadUrl"
              @change="uploadChange"
              :data="{ remark: '白皮书资料领取封面' }"
              :show-upload-list="false"
              :beforeUpload="beforeFaceUpload"
            >
              <div>
                <a-button icon="cloud-upload"> 重新上传</a-button>
                <span class="common-mute">
                  请上传宽高比为 750 : 1500px，并且小于1 MB的图片</span
                >
              </div>
            </a-upload>
          </div>
        </div>
      </a-form-model-item>
      <template v-if="form.codeType === 1">
        <a-form-model-item label="选择资料" required>
          <a-input
            class="vd-input-s"
            placeholder="请输入资料名"
            v-model="searchForm.name"
          />
          <a-input
            class="vd-input-xs"
            placeholder="创建人工号"
            v-model="searchForm.code"
            style="margin-left: 16px"
          />
          <a-select
            style="width: 216px;margin-left: 16px"
            v-model="searchForm.subType"
            placeholder="请选择资料学科"
          >
            <template v-for="item in sub_list">
              <a-select-option :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </template>
          </a-select>
          <a-button
            style="margin-left: 8px"
            icon="search"
            type="primary"
            @click="searchMaterial"
          />
          <div style="display: flex;">
            <div style="width: 60%">
              <a-table
                :pagination="materialPagination"
                :data-source="list"
                :defaultExpandAllRows="true"
                :loading="loading"
                row-key="id"
                :scroll="{ y: 312 }"
                :customRow="rowClick"
                size="small"
              >
                <a-table-column
                  title="资料名称"
                  align="center"
                  data-index="name"
                />
                <a-table-column
                  title="资料类型"
                  align="center"
                  data-index="type"
                >
                  <template slot-scope="text">
                    {{ text === 1 ? '文本资料' : '视频资料' }}
                  </template>
                </a-table-column>
                <a-table-column
                  title="创建时间"
                  align="center"
                  data-index="add_time"
                />
              </a-table>
            </div>

            <div style="width: 40%;margin-left: 8px;">
              <div>
                <span style="font-weight: bold">已选资料:</span>
                <span class="common-mute" style="float: right;"
                  >最多关联20个</span
                >
              </div>
              <template v-if="selectedMaterial.length > 0">
                <draggable
                  v-model="selectedMaterial"
                  handle=".icon-move"
                  class="draggable"
                >
                  <div
                    class="item"
                    v-for="(item, index) in selectedMaterial"
                    :key="item.id"
                    style="display: flex"
                  >
                    <div style="display: flex;flex-grow: 1">
                      {{ index + 1 }}. {{ item.name }}
                    </div>
                    <span>
                      <a-icon
                        class="icon-move draggable-icon"
                        type="drag"
                      ></a-icon>
                      <span class="draggable-remove" @click="removeBook(item)"
                        >移除</span
                      >
                    </span>
                  </div>
                </draggable>
              </template>
            </div>
          </div>
        </a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item label="生成的资料包:" required>
          <template v-if="materialGroup.length > 0">
            <template v-for="(item, index) in materialGroup">
              <a-tag
                :key="item.name"
                closable
                @click="switchPackage(index)"
                @close="() => removePackage(index)"
              >
                <a-badge
                  :status="index === now_edit ? 'processing' : 'default'"
                  :text="item.name"
                />
              </a-tag>
            </template>
          </template>
        </a-form-model-item>
        <template v-if="materialGroup.length > 0">
          <a-form-model-item label="当前资料包中资料">
            <a-input
              class="vd-input-s"
              placeholder="请输入资料名"
              v-model="searchForm.name"
            />
            <a-input
              class="vd-input-s"
              placeholder="请输入创建人工号"
              v-model="searchForm.code"
              style="margin-left: 16px"
            />
            <a-input
              class="vd-input-s"
              placeholder="请选择资料学科"
              v-model="searchForm.subType"
              style="margin-left: 16px"
            />
            <a-button
              style="margin-left: 8px"
              icon="search"
              type="primary"
              @click="searchMaterial"
            />
            <div style="display: flex;">
              <div style="width: 60%">
                <!-- 资料位置 -->
                <a-table
                  :pagination="materialPagination"
                  :data-source="list"
                  :defaultExpandAllRows="true"
                  row-key="id"
                  :scroll="{ y: 312 }"
                  :customRow="rowClicks"
                  size="small"
                  bordered
                >
                  <a-table-column
                    title="资料名称"
                    align="center"
                    data-index="name"
                  />
                  <a-table-column
                    title="资料类型"
                    align="center"
                    data-index="type"
                  >
                    <template slot-scope="text">
                      {{ text === 1 ? '文本资料' : '视频资料' }}
                    </template>
                  </a-table-column>
                  <a-table-column
                    title="创建时间"
                    align="center"
                    data-index="add_time"
                  />
                </a-table>
              </div>
              <div style="width: 40%;margin-left: 8px;">
                <span style="font-weight: bold">已选资料:</span>
                <span class="common-mute" style="float: right;"
                  >最多关联20个</span
                >
                <draggable
                  v-model="materialGroup[now_edit]['book_list']"
                  handle=".icon-move"
                  class="draggable"
                >
                  <div
                    class="item"
                    v-for="(item, index) in materialGroup[now_edit][
                      'book_list'
                    ]"
                    :key="item.id"
                    style="display: flex"
                  >
                    <div style="display: flex;flex-grow: 1">
                      {{ index + 1 }}. {{ item.name }}
                    </div>
                    <span>
                      <a-icon
                        class="icon-move draggable-icon"
                        type="drag"
                      ></a-icon>
                      <span class="draggable-remove" @click="removeBook_s(item)"
                        >移除</span
                      >
                    </span>
                  </div>
                </draggable>
              </div>
            </div>
          </a-form-model-item>
        </template>
      </template>
      <a-row type="flex" justify="center">
        <a-col :span="4">
          <a-button style="margin-left: 8px" type="primary" @click="submit()"
            >提交</a-button
          >
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import bookHead from '@/assets/book-head.png'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { book_modify_package, getBookList } from '@/api/book'
import { get_area_tree } from '@/api/auth'
import { get_sub, AdminByAreaApi } from '@/api'
import draggable from 'vuedraggable'

export default {
  name: 'DetailAdd',
  components: { draggable },
  data() {
    let uploadUrl = this.UPLOAD_URL
    return {
      uploadUrl,
      bookHead,
      current: 0,
      sub_list: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      areaTree: [],
      adminList: [],
      selectPath: [],
      selectList: [],
      /* 资料相关 */
      searchForm: {
        name: undefined,
        code: undefined,
        subType: undefined,
      },
      materialPagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.materialPagination.current = page
          this.searchMaterial()
        },
      },
      form: {
        codeType: 1,
        due_time: '',
        fengmian: 'https://image.sdwx.zgkfpt.cn/155be8a/book/fengmian.png',
        fenxiang: 'https://image.sdwx.zgkfpt.cn/155be8a/book/fenxiang.jpg',
      },
      rules: {
        codeType: [
          { required: true, message: '请选择资料发布类型', trigger: 'blur' },
        ],
        due_time: [
          { required: true, message: '请设置保存时间', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请填写资料名称', trigger: 'blur' },
          { max: 20, message: '名称限20字以内', trigger: 'change' },
        ],
      },
      rowClick: (record) => ({
        on: {
          click: () => {
            if (this.selectedMaterial.length >= 20) {
              this.$message.info({
                content: '已超出添加上限',
                key: 'unique_book',
              })
              return false
            }
            for (let i = 0; i < this.selectedMaterial.length; i++) {
              if (this.selectedMaterial[i]['id'] === record['id']) {
                this.$message.info({
                  content: '已添加该资料',
                  key: 'unique_book',
                })
                return false
              }
            }
            /* 添加 */
            this.selectedMaterial.push(record)
          },
        },
      }),
      rowClicks: (record) => ({
        on: {
          click: () => {
            if (this.materialGroup[this.now_edit]['book_list'].length >= 20) {
              this.$message.info({
                content: '已超出添加上限',
                key: 'unique_book',
              })
              return false
            }
            for (
              let i = 0;
              i < this.materialGroup[this.now_edit]['book_list'].length;
              i++
            ) {
              if (
                this.materialGroup[this.now_edit]['book_list'][i]['id'] ===
                record['id']
              ) {
                this.$message.info({
                  content: '已添加该资料',
                  key: 'unique_book',
                })
                return false
              }
            }
            /* 添加 */
            this.materialGroup[this.now_edit]['book_list'].push(record)
          },
        },
      }),
      list: [],
      loading: {
        size: 'large',
        spinning: false,
      },
      selectedMaterial: [],
      // 多资料
      new_name: '',
      now_edit: 0,
      materialGroup: [],
    }
  },
  created() {
    // 获取管理地区信息
    get_area_tree().then((res) => {
      if (res['code'] === 1) {
        this.areaTree = res['areaTree']
      }
    })
    get_sub('item_type').then((res) => {
      if (res['code'] === 1) {
        this.sub_list = res['list']
      }
    })
    this.searchMaterial()
  },
  methods: {
    onChanges(e) {
      let status = e.file.status
      if (status === 'done') {
        this.form.fenxiang = e.file.response.info.web_url
      }
    },
    beforeShareUpload(file) {
      //读取图片数据
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          // //加载图片获取图片真实宽度和高度
          let image = new Image()
          image.onload = () => {
            let height = image.height
            let width = image.width
            if (height / width === 0.8) {
              resolve(true)
            } else {
              this.$message.error('图片比例不正确')
              reject('比例错误')
            }
          }
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    uploadChange(e) {
      let status = e.file.status
      if (status === 'done') {
        this.form.fengmian = e.file.response.info.web_url
      }
    },
    beforeFaceUpload(file) {
      //读取图片数据
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          // //加载图片获取图片真实宽度和高度
          let image = new Image()
          image.onload = () => {
            let height = image.height
            let width = image.width
            if (height / width === 2) {
              resolve(true)
            } else {
              this.$message.error('图片比例不正确')
              reject('比例错误')
            }
          }
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    removeBook_s(item) {
      this.materialGroup[this.now_edit]['book_list'] = this.materialGroup[
        this.now_edit
      ]['book_list'].filter((it) => {
        return it.id !== item.id
      })
    },
    removePackage(index) {
      if (this.now_edit >= index) {
        this.now_edit = 0
      }
      this.materialGroup.splice(index, 1)
    },
    switchPackage(index) {
      this.now_edit = index
    },
    // 多资料包
    addNewPackage() {
      if (!this.new_name) {
        this.$message.warning('请输入资料组名称')
        return false
      }
      if (this.new_name.length >= 15) {
        this.$message.warning('资料组名称控制在15个字符内!')
        return false
      }
      if (this.materialGroup.length >= 5) {
        this.$message.warning('资料组最多添加5个!')
        return false
      }
      // 检测重名
      let two_name = false
      this.materialGroup.forEach((it) => {
        if (it.name === this.new_name) {
          two_name = true
        }
      })
      if (two_name) {
        this.$message.warning('该名称已经存在!')
        this.new_name = ''
        return false
      }
      this.materialGroup.push({
        name: this.new_name,
        book_list: [],
      })
      this.new_name = ''
    },
    // 单资料包
    searchMaterial() {
      this.loading.spinning = true
      getBookList({
        name: this.searchForm.name,
        code: this.searchForm.code,
        subType: this.searchForm.subType,
        current: this.materialPagination.current,
        pageSize: this.materialPagination.pageSize,
      }).then((res) => {
        this.loading.spinning = false
        if (res['code'] === 1) {
          this.list = res['list']
          this.materialPagination.total = res['total']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    removeBook(item) {
      this.selectedMaterial = this.selectedMaterial.filter((it) => {
        return it.id !== item.id
      })
    },
    /* 推广员相关 */
    selectAdmin() {
      if (this.selectPath.length === 0) {
        this.$message.warning('请选择地区')
        return false
      }
      AdminByAreaApi({ area_path: this.selectPath }).then((res) => {
        if (res['code'] === 1) {
          // 该地区下的用户
          this.adminList = res['admin_list']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    // 用户检测重复
    selectItem(item) {
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i]['id'] === item['id']) {
          this.$message.info({
            content: '重复添加用户已自动去除',
            key: 'unique_member',
          })
          return false
        }
      }
      this.selectList.push(item)
    },
    selectAll() {
      // 当前的成员列表
      if (this.adminList.length <= 0) {
        this.$message.warning('请先按地区查询推广人')
        return false
      }
      this.adminList.forEach((item) => {
        this.selectItem(item)
      })
    },
    removeAdmin(selected) {
      this.selectList = this.selectList.filter((item) => {
        return item.id !== selected
      })
    },
    useDefaultFace() {
      this.form.fengmian =
        'https://image.sdwx.zgkfpt.cn/155be8a/book/fengmian.png'
    },
    useDefaultFenxiang() {
      this.form.fenxiang =
        'https://image.sdwx.zgkfpt.cn/155be8a/book/fenxiang.jpg'
    },
    /* 日期相关 */
    dateChange(dates) {
      this.form.due_time = dates
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day')
    },
    selectDate(date) {
      switch (date) {
        case 7:
          this.form.due_time = moment()
            .add(1, 'weeks')
            .endOf('days')
          break
        case 30:
          this.form.due_time = moment()
            .add(1, 'months')
            .endOf('days')
          break
        case 90:
          this.form.due_time = moment()
            .add(3, 'months')
            .endOf('days')
          break
        case 180:
          this.form.due_time = moment()
            .add(6, 'months')
            .endOf('days')
          break
        case 360:
          this.form.due_time = moment()
            .add(1, 'years')
            .endOf('days')
          break
        default:
          console.log('未知类型')
          break
      }
    },
    moment,
    submit() {
      // 检测
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            (this.list.length === 0 && this.form.codeType === 1) ||
            (this.materialGroup.length === 0 && this.form.codeType === 2)
          ) {
            this.$message.warning('请选择资料')
            return false
          }
          // 提交数据
          book_modify_package({
            name: this.form.name,
            due_time: this.form.due_time,
            share: this.form.fenxiang,
            face: this.form.fengmian,
            book_list: this.selectedMaterial,
          }).then((res) => {
            if (res.code === 1) {
              this.$confirm({
                title: '成功',
                content: '成功创建是否跳转资料包管理页面',
                okText: '确定',
                cancelText: '继续添加',
                onOk: () => {
                  this.$router.push({ path: '/book/package' })
                },
              })
            } else {
              this.$message.warning(res.msg)
            }
          })
        } else {
          this.$message.warning('请检查输入是否存在问题')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.head-button {
  position: absolute;
  bottom: 80px;
  width: 140px;
  margin-left: 63px;
  line-height: 40px;
  border-radius: 45px;
  font-size: 16px;
  text-align: center;
  background: #fc3a51;
  color: #fff;
  cursor: pointer;
}

.head-message {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 10%;
}

.head-button-group {
  position: absolute;
  display: flex;
  top: 20%;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  flex-wrap: wrap;
}

.head-button-group span {
  width: 45%;
  margin: 0 6px 20px 6px;
  text-align: center;
  background: #f7f8f9;
  border-radius: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
}

.icon-move {
  font-size: 18px;
  vertical-align: middle;
  margin-right: 8px;
  cursor: move;
}

.draggable {
  height: 312px;
  overflow-y: scroll;
}

.draggable-icon {
  font-size: 18px;
  vertical-align: middle;
  margin-right: 8px;
  cursor: move;
}

.draggable-remove {
  vertical-align: middle;
  cursor: pointer;
  margin-right: 8px;
}
</style>
